export default __webpack_public_path__ + "static/media/T1-output.e18f81ae.png";